(function() {
  'use strict';

  if (window.BilliardCityDesktopSidebarFlyout) return;
  window.BilliardCityDesktopSidebarFlyout = {
    initialized: true
  };

  var ROOT_SELECTOR = 'body:not(.template-password):not(.template-giftcard) [data-section-type="sidebar-section"] #SiteNav';
  var ITEM_SELECTOR = '.site-nav--has-submenu';
  var SUBMENU_SELECTOR = ':scope > .site-nav__submenu';
  var TRIGGER_SELECTOR = ':scope > .site-nav__link';
  var LAYER_SELECTOR = '[data-desktop-sidebar-flyout-layer]';
  var ACTIVE_CLASS = 'is-desktop-flyout-active';
  var PANEL_ACTIVE_CLASS = 'is-visible';
  var OPEN_DELAY = 50;
  /*
    Closing waits 280ms, and the timer is cancelled the moment the pointer is
    back on the parent row, on a panel or on the bridge between them - the
    three are one hover area. 220ms closed a panel under a pointer that had
    only clipped the row below on its way across.
  */
  var CLOSE_DELAY = 280;
  /*
    THE BRIDGE. A panel sits flush against the row that opened it - measured
    at 1280 the gap is -0.6px, the panel overlapping the column - so there is
    no seam to fall through sideways. What collapsed panels was the PATH: a
    pointer travelling from a row's label to a far item of its panel crosses
    the rows below on the way, and each of those took the hover and switched
    or closed the panel. Measured at 1280x900 before this change, a diagonal
    from the label to the panel's last row failed on 12 of the 15 menus at a
    steady pace (10 when quick), and on 18 of the 47 second-level panels.

    So while the pointer is moving toward an open panel, an invisible element
    covers the triangle between the pointer and the panel's near edge, and
    the rows under it are not hovered. It holds only while the pointer keeps
    travelling toward the panel: once it turns away, or rests for AIM_DELAY,
    the bridge is withdrawn and whatever is under the pointer takes the hover
    as before - so running down the list still switches panels row by row.
  */
  var AIM_DELAY = 280;
  /* How far the aim triangle reaches above and below the panel's corners. */
  var AIM_TOLERANCE = 24;
  /* A pointer that rested longer than this starts a new movement. */
  var MOVE_GAP = 120;
  /*
    The sidebar column is 184px wide (theme.scss.liquid:7098-7102). Panels
    match it so the flyout reads as the column continuing, and only widen when
    a label genuinely will not fit - capped so a long size name cannot push a
    panel across half the screen.
  */
  var COLUMN_WIDTH = 184;
  var MIN_PANEL_WIDTH = 184;
  var MAX_PANEL_WIDTH = 248;
  var VIEWPORT_GAP = 8;
  /*
    One glyph across both levels; level-1's +/- is restored on deactivate.
    Written as an escape, not a literal: the asset is served without a charset
    parameter, so a literal U+203A decodes as "a€º" if the response is read as
    Latin-1. buildPanel() already uses the escape for the same reason.
  */
  var CHEVRON = '›';

  var root = null;
  var layer = null;
  var bridge = null;
  var bridgeLevel = -1;
  var aimTimer = 0;
  var trail = [];
  var activeSourceItems = [];
  var panels = [];
  var openTimer = 0;
  var closeTimer = 0;
  var isEnabled = false;
  var desktopQuery = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;
  var pointerQuery = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  var originalFocusEl = null;

  function matchesDesktop() {
    return Boolean(desktopQuery && pointerQuery && desktopQuery.matches && pointerQuery.matches);
  }

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function getDirectSubmenu(item) {
    if (!item) return null;
    try {
      return item.querySelector(SUBMENU_SELECTOR);
    } catch (error) {
      var children = item.children;
      for (var i = 0; i < children.length; i += 1) {
        if (children[i].classList && children[i].classList.contains('site-nav__submenu')) {
          return children[i];
        }
      }
    }
    return null;
  }

  function getDirectTrigger(item) {
    if (!item) return null;
    try {
      return item.querySelector(TRIGGER_SELECTOR);
    } catch (error) {
      var children = item.children;
      for (var i = 0; i < children.length; i += 1) {
        if (children[i].classList && children[i].classList.contains('site-nav__link')) {
          return children[i];
        }
      }
    }
    return null;
  }

  /*
    THE LABEL IS THE LINK'S TITLE, PRINTED AS IT IS (2026-09-28, the owner's
    report). This stripped every "+" and every "-" out of the text, and the
    menu carries titles with hyphens in them - GS-Series, G-Series, G-Core
    Shafts, Intimidator i-Shafts - which reached the flyout as GSSeries and
    GCore Shafts. The strip was there for the theme's own expander glyph,
    which the vintage markup prints inside the link, and the fix is to take
    the label from the span that holds the TITLE and nothing else. The
    fallbacks below do include the glyph, so they drop one only where it
    stands alone between spaces - never a hyphen inside a word.
  */
  function getItemLabel(item) {
    var label = item ? item.querySelector(':scope > .site-nav__link .site-nav__label') : null;
    if (label) return label.textContent.replace(/\s+/g, ' ').trim();
    var trigger = getDirectTrigger(item);
    return (trigger || item).textContent.replace(/(^|\s)[+\-](?=\s|$)/g, '$1').replace(/\s+/g, ' ').trim();
  }

  function ensureLayer() {
    if (layer && document.body.contains(layer)) return layer;
    layer = document.querySelector(LAYER_SELECTOR);
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'desktop-sidebar-flyout-layer';
      layer.setAttribute('data-desktop-sidebar-flyout-layer', '');
      document.body.appendChild(layer);
    }
    return layer;
  }

  function removeLayer() {
    if (layer && layer.parentNode) {
      layer.parentNode.removeChild(layer);
    }
    layer = null;
    bridge = null;
    bridgeLevel = -1;
  }

  function clearTimer(timerId) {
    if (timerId) window.clearTimeout(timerId);
    return 0;
  }

  function cancelClose() {
    closeTimer = clearTimer(closeTimer);
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = window.setTimeout(closeAll, CLOSE_DELAY);
  }

  function clearOpenTimer() {
    openTimer = clearTimer(openTimer);
  }

  /*
    While the flyouts are running, a level-1 parent is not an accordion that
    expands and collapses - it points sideways at a panel. So the +/- becomes
    the same chevron the panel rows use, in both states. The original glyph is
    kept on the node and restored when the flyouts deactivate, which is what
    keeps the accordion below 1024px (and on touch) untouched.
  */
  function setRootIndicator(item, isOpen) {
    var trigger = getDirectTrigger(item);
    var indicator = trigger ? trigger.querySelector('.site-nav__link__text') : null;
    if (!indicator) return;
    if (indicator.__bcOriginalGlyph === undefined) {
      indicator.__bcOriginalGlyph = indicator.textContent;
    }
    indicator.textContent = CHEVRON;
  }

  function syncRootIndicators(useChevron) {
    if (!root) return;
    var indicators = root.querySelectorAll('.list--nav > .site-nav--has-submenu > .site-nav__link .site-nav__link__text');
    for (var i = 0; i < indicators.length; i += 1) {
      var indicator = indicators[i];
      if (useChevron) {
        if (indicator.__bcOriginalGlyph === undefined) {
          indicator.__bcOriginalGlyph = indicator.textContent;
        }
        indicator.textContent = CHEVRON;
      } else if (indicator.__bcOriginalGlyph !== undefined) {
        indicator.textContent = indicator.__bcOriginalGlyph;
        delete indicator.__bcOriginalGlyph;
      }
    }
  }

  function clearActiveFromLevel(level) {
    for (var i = level; i < activeSourceItems.length; i += 1) {
      if (activeSourceItems[i]) {
        activeSourceItems[i].classList.remove(ACTIVE_CLASS);
        if (activeSourceItems[i].parentNode && activeSourceItems[i].parentNode.classList && activeSourceItems[i].parentNode.classList.contains('list--nav')) {
          setRootIndicator(activeSourceItems[i], false);
        }
      }
    }
    activeSourceItems.length = level;

    for (var j = panels.length - 1; j >= level; j -= 1) {
      if (panels[j] && panels[j].parentNode) {
        panels[j].parentNode.removeChild(panels[j]);
      }
      panels.pop();
    }
  }

  function closeAll() {
    clearOpenTimer();
    cancelClose();
    hideBridge();
    clearActiveFromLevel(0);
    originalFocusEl = null;
  }

  function deactivate() {
    closeAll();
    if (root) {
      root.removeEventListener('mouseover', onRootMouseOver, true);
      root.removeEventListener('mouseout', onRootMouseOut, true);
      root.removeEventListener('focusin', onRootFocusIn, true);
      root.removeEventListener('focusout', onRootFocusOut, true);
      root.removeEventListener('click', onRootClick, true);
    }
    document.removeEventListener('keydown', onKeyDown, true);
    document.removeEventListener('mousemove', onPointerMove, true);
    trail = [];
    syncRootIndicators(false);
    removeLayer();
    isEnabled = false;
  }

  function activate() {
    root = getRoot();
    if (!root || isEnabled || !matchesDesktop()) return;
    ensureLayer();
    root.addEventListener('mouseover', onRootMouseOver, true);
    root.addEventListener('mouseout', onRootMouseOut, true);
    root.addEventListener('focusin', onRootFocusIn, true);
    root.addEventListener('focusout', onRootFocusOut, true);
    root.addEventListener('click', onRootClick, true);
    layer.addEventListener('mouseover', onLayerMouseOver, true);
    layer.addEventListener('mouseout', onLayerMouseOut, true);
    layer.addEventListener('focusin', onLayerFocusIn, true);
    layer.addEventListener('focusout', onLayerFocusOut, true);
    layer.addEventListener('click', onLayerClick, true);
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('mousemove', onPointerMove, true);
    syncRootIndicators(true);
    isEnabled = true;
  }

  function refresh() {
    if (matchesDesktop()) {
      activate();
    } else if (isEnabled || layer) {
      deactivate();
    }
  }

  function closestItemWithSubmenu(target, container) {
    var item = target && target.closest ? target.closest(ITEM_SELECTOR) : null;
    if (!item || (container && !container.contains(item))) return null;
    return getDirectSubmenu(item) ? item : null;
  }

  function onRootMouseOver(event) {
    if (!matchesDesktop()) return;
    var item = closestItemWithSubmenu(event.target, root);
    if (item) {
      if (item.contains(event.relatedTarget)) return;
      queueOpen(item, getDirectTrigger(item), 0);
      return;
    }
    /*
      A row without a submenu. The parent's own mouseout used to schedule the
      close, but a pointer can now reach this row off the bridge, whose
      mouseout keeps panels open - so the row asks for the close itself.
    */
    if (activeSourceItems.length) scheduleClose();
  }

  function onRootMouseOut(event) {
    if (!matchesDesktop()) return;
    var next = event.relatedTarget;
    if (next && (root.contains(next) || (layer && layer.contains(next)))) return;
    scheduleClose();
  }

  function onRootFocusIn(event) {
    if (!matchesDesktop()) return;
    var item = closestItemWithSubmenu(event.target, root);
    if (!item) return;
    originalFocusEl = originalFocusEl || getDirectTrigger(item);
    queueOpen(item, getDirectTrigger(item), 0);
  }

  function onRootFocusOut(event) {
    if (!matchesDesktop()) return;
    if (root.contains(event.relatedTarget) || (layer && layer.contains(event.relatedTarget))) return;
    scheduleClose();
  }

  function onRootClick(event) {
    if (!matchesDesktop()) return;
    var trigger = event.target.closest ? event.target.closest('.site-nav__link') : null;
    var item = trigger ? trigger.parentNode : null;
    if (!item || !item.matches || !item.matches(ITEM_SELECTOR) || !root.contains(item) || !getDirectSubmenu(item)) return;
    if (trigger.tagName && trigger.tagName.toLowerCase() === 'button') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openFromItem(item, trigger, 0);
    }
  }

  function onLayerMouseOut(event) {
    if (!layer || layer.contains(event.relatedTarget) || (root && root.contains(event.relatedTarget))) return;
    scheduleClose();
  }

  function onLayerMouseOver(event) {
    cancelClose();
    var row = getFlyoutRow(event.target);
    if (!row || row.contains(event.relatedTarget)) return;
    handleFlyoutRowEnter(row);
  }

  function onLayerFocusIn(event) {
    cancelClose();
    var row = getFlyoutRow(event.target);
    if (!row) return;
    handleFlyoutRowEnter(row);
  }

  function onLayerFocusOut(event) {
    if (!layer || layer.contains(event.relatedTarget) || (root && root.contains(event.relatedTarget))) return;
    scheduleClose();
  }

  function onLayerClick(event) {
    var row = getFlyoutRow(event.target);
    var sourceItem = row ? row.__desktopSidebarSourceItem : null;
    if (!sourceItem || !getDirectSubmenu(sourceItem)) return;
    event.preventDefault();
    handleFlyoutRowEnter(row);
  }

  function getFlyoutRow(target) {
    if (!target || !target.closest || !layer) return null;
    var row = target.closest('.desktop-sidebar-flyout__item');
    return row && layer.contains(row) ? row : null;
  }

  function handleFlyoutRowEnter(row) {
    var panel = row.closest('[data-desktop-sidebar-flyout-panel]');
    var level = panel ? parseInt(panel.getAttribute('data-flyout-level'), 10) : NaN;
    var sourceItem = row.__desktopSidebarSourceItem;
    var sourceSubmenu = getDirectSubmenu(sourceItem);

    if (!panel || isNaN(level) || !sourceItem) return;

    cancelClose();
    clearOpenTimer();
    if (sourceSubmenu && activeSourceItems[level + 1] === sourceItem && panels[level + 1]) {
      setPanelItemActive(panel, row);
      return;
    }
    /*
      Queued like an open, including for a row with no submenu of its own, so
      a pointer that crosses this row on its way to the deeper panel does not
      close that panel: the move event that follows raises the bridge and
      cancels the queue.
    */
    openTimer = window.setTimeout(function() {
      setPanelItemActive(panel, row);
      if (sourceSubmenu) {
        openFromItem(sourceItem, row, level + 1);
      } else {
        clearActiveFromLevel(level + 1);
      }
    }, OPEN_DELAY);
  }

  function onKeyDown(event) {
    if (!isEnabled || (event.key !== 'Escape' && event.keyCode !== 27)) return;
    if (!activeSourceItems.length) return;
    event.preventDefault();
    var focusTarget = originalFocusEl || getDirectTrigger(activeSourceItems[0]);
    closeAll();
    if (focusTarget && focusTarget.focus) focusTarget.focus();
  }

  function queueOpen(item, anchor, level) {
    cancelClose();
    clearOpenTimer();
    /* Back on the row whose panel is already open: keep that panel, never rebuild it. */
    if (activeSourceItems[level] === item && panels[level]) return;
    openTimer = window.setTimeout(function() {
      openFromItem(item, anchor, level);
    }, OPEN_DELAY);
  }

  /*
    The pointer's last few positions, restarted after a rest so an old
    movement cannot count as travel toward a panel.
  */
  function onPointerMove(event) {
    var now = Date.now();
    var point = { x: event.clientX, y: event.clientY, t: now };
    var last = trail[trail.length - 1];
    if (last && now - last.t > MOVE_GAP) trail = [last];
    trail.push(point);
    if (trail.length > 4) trail.shift();

    if (!panels.length) {
      hideBridge();
      return;
    }

    var target = aimTarget(point);
    if (target && movingToward(trail[0], point, target.rect)) {
      showBridge(target.level, point, target.rect);
      /* Whatever the rows crossed on the way queued is dropped. */
      clearOpenTimer();
      cancelClose();
      aimTimer = clearTimer(aimTimer);
      aimTimer = window.setTimeout(releaseAim, AIM_DELAY);
    } else if (bridge && !bridge.hidden) {
      releaseAim();
    }
  }

  /*
    The panel the pointer could be heading for: the deepest open panel whose
    near edge is still to the right of the pointer, while the pointer is on
    the column (level 0) or on the panel before it - or already on the bridge
    raised for that panel.
  */
  function aimTarget(point) {
    for (var level = panels.length - 1; level >= 0; level -= 1) {
      var panel = panels[level];
      if (!panel) continue;
      var rect = panel.getBoundingClientRect();
      if (point.x >= rect.left) continue;
      var source = level === 0 ? root : panels[level - 1];
      if (!source) continue;
      var from = source.getBoundingClientRect();
      var onSource = point.x >= from.left && point.x <= from.right && point.y >= from.top && point.y <= from.bottom;
      if (onSource || (bridgeLevel === level && bridge && !bridge.hidden)) {
        return { level: level, rect: rect };
      }
    }
    return null;
  }

  /*
    Travelling toward the panel means the angle to its upper corner is
    closing from above and the angle to its lower corner from below - the
    pointer is inside the triangle it forms with the panel's near edge and
    moving deeper into it.
  */
  function movingToward(from, to, rect) {
    if (!from || (from.x === to.x && from.y === to.y)) return false;
    if (from.x >= rect.left || to.x >= rect.left) return false;
    var upperY = rect.top - AIM_TOLERANCE;
    var lowerY = rect.bottom + AIM_TOLERANCE;
    var slope = function(p, y) {
      return (y - p.y) / (rect.left - p.x);
    };
    return slope(to, upperY) < slope(from, upperY) && slope(to, lowerY) > slope(from, lowerY);
  }

  function showBridge(level, point, rect) {
    ensureLayer();
    if (!bridge || !layer.contains(bridge)) {
      bridge = document.createElement('div');
      bridge.className = 'desktop-sidebar-flyout__bridge';
      bridge.setAttribute('aria-hidden', 'true');
      bridge.addEventListener('click', onBridgeClick);
      layer.appendChild(bridge);
    }
    var left = Math.floor(point.x) - 6;
    var right = Math.ceil(rect.left) + 1;
    var top = Math.floor(Math.min(rect.top, point.y)) - 6;
    var bottom = Math.ceil(Math.max(rect.bottom, point.y)) + 6;
    var width = right - left;
    var pointerY = point.y - top;
    bridge.style.left = left + 'px';
    bridge.style.top = top + 'px';
    bridge.style.width = width + 'px';
    bridge.style.height = (bottom - top) + 'px';
    bridge.style.clipPath = 'polygon(0px ' + (pointerY - 6) + 'px, ' + width + 'px ' + (rect.top - top) + 'px, ' + width + 'px ' + (rect.bottom - top) + 'px, 0px ' + (pointerY + 6) + 'px)';
    bridge.hidden = false;
    bridgeLevel = level;
  }

  function hideBridge() {
    aimTimer = clearTimer(aimTimer);
    if (bridge) bridge.hidden = true;
    bridgeLevel = -1;
  }

  /* The bridge is withdrawn and the element under the pointer takes the hover it held back. */
  function releaseAim() {
    var wasShown = Boolean(bridge && !bridge.hidden);
    hideBridge();
    var point = trail[trail.length - 1];
    if (!wasShown || !point) return;
    routeTarget(document.elementFromPoint(point.x, point.y));
  }

  function routeTarget(target) {
    if (!target || !matchesDesktop()) return;
    if (layer && layer.contains(target)) {
      cancelClose();
      var row = getFlyoutRow(target);
      if (row) handleFlyoutRowEnter(row);
      return;
    }
    if (root && root.contains(target)) {
      var item = closestItemWithSubmenu(target, root);
      if (item) {
        queueOpen(item, getDirectTrigger(item), 0);
      } else if (activeSourceItems.length) {
        scheduleClose();
      }
      return;
    }
    scheduleClose();
  }

  /* A click that lands on the bridge belongs to what is under it. */
  function onBridgeClick(event) {
    hideBridge();
    var target = document.elementFromPoint(event.clientX, event.clientY);
    if (!target || target === bridge) return;
    var control = target.closest ? target.closest('a, button') : null;
    (control || target).click();
  }

  function openFromItem(item, anchor, level) {
    var submenu = getDirectSubmenu(item);
    if (!submenu || !matchesDesktop()) return;
    ensureLayer();
    clearActiveFromLevel(level);

    item.classList.add(ACTIVE_CLASS);
    activeSourceItems[level] = item;
    if (item.parentNode && item.parentNode.classList && item.parentNode.classList.contains('list--nav')) {
      setRootIndicator(item, true);
    }

    var panel = buildPanel(submenu, level);
    if (!panel) return;
    layer.appendChild(panel);
    panels[level] = panel;
    positionPanel(panel, anchor, level);
    window.requestAnimationFrame(function() {
      panel.classList.add(PANEL_ACTIVE_CLASS);
    });
  }

  function buildPanel(submenu, level) {
    var children = [];
    for (var i = 0; i < submenu.children.length; i += 1) {
      if (submenu.children[i].tagName && submenu.children[i].tagName.toLowerCase() === 'li') {
        children.push(submenu.children[i]);
      }
    }
    if (!children.length) return null;

    var panel = document.createElement('div');
    panel.className = 'desktop-sidebar-flyout';
    panel.setAttribute('data-desktop-sidebar-flyout-panel', '');
    panel.setAttribute('data-flyout-level', String(level));

    var list = document.createElement('ul');
    list.className = 'desktop-sidebar-flyout__list';
    panel.appendChild(list);

    children.forEach(function(sourceItem) {
      var row = document.createElement('li');
      var sourceSubmenu = getDirectSubmenu(sourceItem);
      var sourceLink = getDirectTrigger(sourceItem);
      var isLink = sourceLink && sourceLink.tagName && sourceLink.tagName.toLowerCase() === 'a';
      var control = document.createElement(isLink ? 'a' : 'button');
      var label = document.createElement('span');
      var indicator = document.createElement('span');

      row.className = 'desktop-sidebar-flyout__item';
      row.__desktopSidebarSourceItem = sourceItem;

      control.className = 'desktop-sidebar-flyout__link';
      if (isLink) {
        control.href = sourceLink.getAttribute('href') || '#';
        if (sourceLink.getAttribute('aria-current')) {
          control.setAttribute('aria-current', sourceLink.getAttribute('aria-current'));
        }
      } else {
        control.type = 'button';
      }

      label.className = 'desktop-sidebar-flyout__label';
      label.textContent = getItemLabel(sourceItem);
      control.appendChild(label);

      indicator.className = 'desktop-sidebar-flyout__indicator';
      indicator.setAttribute('aria-hidden', 'true');
      indicator.textContent = sourceSubmenu ? '›' : '';
      control.appendChild(indicator);

      row.appendChild(control);
      list.appendChild(row);
    });

    return panel;
  }

  function setPanelItemActive(panel, row) {
    var rows = panel.querySelectorAll('.desktop-sidebar-flyout__item');
    for (var i = 0; i < rows.length; i += 1) {
      rows[i].classList.toggle(ACTIVE_CLASS, rows[i] === row);
    }
  }

  /*
    Panels are the column's width. A panel is allowed to grow past it only
    when its own content will not fit: the panel is measured at width:auto
    once, and anything between COLUMN_WIDTH and MAX_PANEL_WIDTH is honoured.
    Wider than that and the label wraps instead, the way the level-1 list
    already wraps.
  */
  function measureNaturalWidth(panel) {
    var previousWidth = panel.style.width;
    panel.style.width = 'auto';
    var natural = Math.ceil(panel.getBoundingClientRect().width);
    panel.style.width = previousWidth;
    return natural;
  }

  function positionPanel(panel, anchor, level) {
    if (!panel || !anchor) return;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var anchorRect = anchor.getBoundingClientRect();
    var previousPanel = level > 0 ? panels[level - 1] : null;
    var previousPanelRect = previousPanel ? previousPanel.getBoundingClientRect() : null;
    /*
      -1 so the panel's hairline lands on the edge it opens from - the column's
      own right line (#SiteNav's border-right, theme.scss.liquid) for the first
      panel, the previous panel's right border for the next: the two lines
      coincide and read as one separator, not a gap the pointer can fall
      through. The first panel used to take the ROW's right edge, a pixel
      inside the column's line, and carried no left line of its own
      (desktop-sidebar-flyout.css): it covered the line and a pixel of the
      column and bled out of it, while the second panel met its parent on a
      crisp hairline. Measured before the fix (2026-09-24): column right 135,
      panel left 133 at 1280; 164 and 162 at 1920.
    */
    var columnRect = root ? root.getBoundingClientRect() : anchorRect;
    var left = previousPanelRect ? previousPanelRect.right - 1 : columnRect.right - 1;
    /* Placed before measuring, so width:auto is resolved where it will sit. */
    panel.style.left = Math.round(left) + 'px';

    var width = Math.max(COLUMN_WIDTH, Math.min(measureNaturalWidth(panel), MAX_PANEL_WIDTH));
    if (left + width > viewportWidth - VIEWPORT_GAP) {
      width = Math.max(MIN_PANEL_WIDTH, viewportWidth - left - VIEWPORT_GAP);
    }
    panel.style.width = width + 'px';

    /*
      The panel top aligns with the row that opened it, and slides up ONLY by
      what it is short of - never past the top gap, never as a flip.

      This is the third version of this block, so the distinction matters.
      The first clamped every panel to viewportHeight - panelHeight, which
      pushed panels opened low back to the top of the screen and broke the
      alignment for every tall list. The second dropped the clamp entirely
      and only lifted enough to guarantee MIN_PANEL_HEIGHT: alignment was
      right and nothing left the viewport, but a row near the bottom got a
      window the size of the room under it and nothing more. Measured on the
      draft at 1280x900: Brands sits at y724-764 with 46 brands, so the panel
      got top 724 and max-height 168 - a 168px window on 1715px of list, four
      brands of forty-six, with the other forty-two behind a scrollbar most
      people will not look for. Nothing was off-screen; it was simply
      unusable, which is what was reported.

      So: work out the height the list actually wants, capped by the viewport,
      and if it will not fit below the anchor, move the top up by exactly the
      shortfall. A list that fits below its row does not move at all - the
      alignment the second version protected is untouched, because the shift
      is zero whenever alignment is possible. A list taller than the screen
      lands at the top gap and gets the whole viewport height, which is the
      most there is to give, and scrolls for the rest.

      scrollHeight is the full content height even while the panel is capped,
      so it can be read without clearing max-height first; the border box is
      what gets positioned, so the two hairlines are added back.
    */
    var borders = panel.offsetHeight - panel.clientHeight;
    var wanted = panel.scrollHeight + (borders > 0 ? borders : 0);
    var available = viewportHeight - (2 * VIEWPORT_GAP);
    /*
      No floor under a short list. A 160px MIN_PANEL_HEIGHT used to be applied
      here to every panel, so a one-row list opened near the bottom was placed
      as if it were 160px tall and floated above its own row: measured at
      1280x900, Ball Rack Sheets (row top 818) got its 38px panel at 732,
      ending 48px above the row - a hole in the hover path that the pointer
      fell through on the way across. A list gets the height it wants, capped
      by the viewport; only a list that does not fit below its row moves up.
    */
    var desired = Math.min(wanted, available);

    var top = anchorRect.top;
    if (top + desired > viewportHeight - VIEWPORT_GAP) {
      top = viewportHeight - VIEWPORT_GAP - desired;
    }
    if (top < VIEWPORT_GAP) top = VIEWPORT_GAP;
    var roomBelow = viewportHeight - top - VIEWPORT_GAP;

    panel.style.top = Math.round(top) + 'px';
    panel.style.maxHeight = Math.round(roomBelow) + 'px';
  }

  function bindQuery(query) {
    if (!query) return;
    if (query.addEventListener) {
      query.addEventListener('change', refresh);
    } else if (query.addListener) {
      query.addListener(refresh);
    }
  }

  function init() {
    root = getRoot();
    refresh();
    bindQuery(desktopQuery);
    bindQuery(pointerQuery);
    document.addEventListener('shopify:section:load', function() {
      deactivate();
      root = getRoot();
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* touched 2026-09-28: the theme kept the pre-5d8dc77 file (28298 bytes against HEAD's 29046) after the push - the sync takes a file when it changes in the newest commit. */
